<nz-form-item class="label-on-top">
  @if (label) {
    <nz-form-label [nzRequired]="isRequired(control)"> {{ label }} </nz-form-label>
  }
  <nz-form-control
    [nzHasFeedback]="nzHasFeedback"
    [nzValidateStatus]="control"
    [nzErrorTip]="errorTemplate"
  >
    @if (showCopy) {
      <div class="copy-group">
        <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
        <span
          class="ant-input-group-addon copy-addon"
          [class.copy-addon-empty]="!copyText()"
          title="Copy"
          (click)="copyValue()"
        >
          <i nz-icon [nzType]="copied ? 'check' : 'copy'"></i>
        </span>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
    }
    <i
      class="icon-position"
      *ngIf="showClear && control?.value"
      nz-icon
      nzType="close-circle"
      nzTheme="fill"
      (click)="control.reset()"
    ></i>
  </nz-form-control>
  <ng-template #errorTemplate>
    {{ control.errors | formError }}
  </ng-template>
</nz-form-item>

<ng-template #inputTemplate>
  <input
    nz-input
    [placeholder]="placeholder"
    [formControl]="control"
    [type]="type"
    class="relative ltr small-font mt-2"
  />
</ng-template>
